<template>
    <article class="page type-page status-publish hentry">

        <div class="entry-content">

            <header class="entry-header missing">
                <h1 class="entry-title">Erm... What are you looking for?</h1>
            </header><!-- .entry-header -->

            <br><br>

            <h2 class="alt-title">404 - Sorry! We don't have this thing here.</h2>

            <div class="cols">
                <div class="col left">
                    <p class="intro">Maybe we have it elsewhere? Try <router-link to="/">our homepage</router-link> - it's probably there. Potentially, it's been moved, or just simply doesn't exist. If you still cannot find it, or would like to discuss a replacement thing, <router-link to="/contact">contact us</router-link>, and we'll check behind the back of the sofa. Just in case.</p>
                </div>
            </div>

            <div class="social-buttons animateIn">
                <ul>
                    <h2 class="title">Follow us!</h2>
                    <li class="facebook"><a href="https://www.facebook.com/altdesignderby/" target="_blank" title="Find us on Facebook"><span class="icon-facebook"></span></a></li>
                    <li class="twitter"><a href="https://twitter.com/_altdesign" target="_blank" title="Follow us on Twitter"><span class="icon-twitter"></span></a></li>
                    <li class="instagram"><a href="https://www.instagram.com/_altdesign/" target="_blank" title="Follow us on Instagram"><span class="icon-instagram"></span></a></li>
                </ul>
            </div>
        </div>


    </article>

</template>

<script>
  export default {
    created () {
      this.$setSeo('Graphic Design Agency / Brand Consultants Midlands | Alt Design', 'Based in Derby, Alt Design are one of the top graphic design agencies in the Midlands specialising in branding, print, and web design. Call us on 01332 208733.')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pages/404.vue